
// Here is code to show two products in row and 4 products in row on listing page
// document.addEventListener("DOMContentLoaded", function() {
//   alert ("hello");
//     const button1 = document.getElementById("button1");
//     const button2 = document.getElementById("button2");
//     const stylesheet = document.getElementById("stylesheet");

//     button1.addEventListener("click", function() {
//         // Load 1.css when Button 1 is clicked
//         stylesheet.href = "2products.css";
//     });

//     button2.addEventListener("click", function() {
//         // Load 2.css when Button 2 is clicked
//         stylesheet.href = "4products.css";
//     });
// });


if (window.innerWidth > 767) {
    document.getElementById("product-grid").classList.add("highlighted");
    
    var gridItems = document.getElementsByClassName("grid__item");
    for (var i = 0; i < gridItems.length; i++) {
        gridItems[i].classList.add("highlighted");
    }
    
    document.getElementById("button2").classList.add("active");
    document.getElementById("button1").classList.remove("active");
}
if (window.innerWidth < 767) {
    document.getElementById("product-grid").classList.remove("highlighted");
    
    var gridItems = document.getElementsByClassName("grid__item");
    for (var i = 0; i < gridItems.length; i++) {
        gridItems[i].classList.remove("highlighted");
    }
    
    document.getElementById("button2").classList.remove("active");
    document.getElementById("button1").classList.add("active");
}

 $(document).ready(function(){
  
        // Add class to the div when the "Add Class" button is clicked
        $("#button2").click(function(){
          $("#product-grid").addClass("highlighted");
          $(".grid__item").addClass("highlighted");
          $("#button1").removeClass("active");
          $(this).addClass("active");
        });

        // Remove class from the div when the "Remove Class" button is clicked
        $("#button1").click(function(){
           $("#product-grid").removeClass("highlighted");
           $(".grid__item").removeClass("highlighted");
           $("#button2").removeClass("active");
           $(this).addClass("active");
        });
    });

